import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input } from '@angular/core';
import {MediaService} from '../peers/media.service';
import {MediaManagerService} from '../services/media/media-manager.service';
import {Modal} from 'ng2-modal';
import { TranslateService } from 'ng2-translate/ng2-translate';
@Component({
  selector: "dskl-tools-share-screen",
  templateUrl: 'share-screen.component.html',
 
})

export class ShareScreenComponent {
  hidden=true;
  
  @ViewChild("noPlugin") noPluginModal: Modal;
  @ViewChild("screenShareNotAvailable") screenShareNotAvailable: Modal;
  
  constructor(private mediaService: MediaManagerService, private translate: TranslateService){}
  open(){
 // this.hidden=false;
  var _this = this;
 
  this.mediaService.shareScreen(function(hasPlugin){
    if (!hasPlugin){
      _this.noPluginModal.open();
    }else{
      //_this.screenShareNotAvailable.open();
    }
  })
  }
  openPluginPage(){
    this.translate.get('SHARE_SCREEN.PLUGIN_URL').subscribe((url: string) => { 
      window.open(url, "_blank").focus();
    });
    
  }
}


// WEBPACK FOOTER //
// /app/src/app/wb/tools/share-screen.component.ts